import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmClearAlertsDialogComponent } from './confirm-clear-alerts-dialog.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmClearAlertsDialogService {
  dialog = inject(MatDialog);


  dialogRef: MatDialogRef<ConfirmClearAlertsDialogComponent>;

  open(): Observable<any> {
    this.dialogRef = this.dialog.open(ConfirmClearAlertsDialogComponent, {
      width: '600px',
      position: {
        top: '70px'
      },
      data: {},
    });

    return this.dialogRef.afterClosed();
  }
}
